'use client';

import clsx from 'clsx';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import HoverPrefetchLink from './hover-prefetch-link';
import { Carousel, CarouselContent, CarouselItem } from './ui/carousel';

const ProductsSlider = props => {
  const { products } = props;

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [carouselApi, setCarouselApi] = useState(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    if (!carouselApi) {
      return;
    }

    const onSelect = () => {
      if (!carouselApi) {
        return;
      }

      setCanScrollPrev(carouselApi.canScrollPrev());
      setCanScrollNext(carouselApi.canScrollNext());
    };
    const onScroll = () => {
      const progress = Math.max(0, Math.min(1, carouselApi.scrollProgress()));
      setScrollProgress(progress * 100);
    };
    const onReInit = () => {
      onSelect();
      onScroll();
    };

    onSelect();
    onScroll();
    carouselApi.on('reInit', onReInit);
    carouselApi.on('select', onSelect);
    carouselApi.on('scroll', onScroll);

    return () => {
      carouselApi.off('reInit', onReInit);
      carouselApi.off('select', onSelect);
      carouselApi.off('scroll', onScroll);
    };
  }, [carouselApi]);

  return (
    <>
      <div className=' relative mx-auto mt-[15px] max-w-[1442px]  pl-3 lg_mt-[30px] lg_pl-0'>
        <Carousel
          opts={{ align: 'start', dragFree: true }}
          setApi={setCarouselApi}
        >
          <CarouselContent className='-ml-[15px] lg_-ml-4'>
            {Array.isArray(products) && products.length > 0
              ? products.map((item, index) =>
                  item.type === 'best-seller' ? (
                    <CarouselItem
                      key={index}
                      className='basis-[255px] pl-[15px] lg_basis-[243px] lg_pl-4'
                    >
                      <HoverPrefetchLink
                        className='group relative block flex-none'
                        href={`/${item.link}`}
                      >
                        <Image
                          src={item.imgurl}
                          width={384}
                          height={563}
                          alt={item.name}
                          className={clsx(
                            'relative z-[2] opacity-100 transition-opacity ease-linear [transition-duration:400ms] lg_group-hover_opacity-0',
                            'h-auto w-[240px] lg_w-[227px]',
                          )}
                        />
                        <Image
                          src={item.hover_image}
                          className={clsx(
                            'absolute left-0 top-0 z-[1] opacity-0 transition-opacity ease-linear [transition-duration:400ms] lg_group-hover_opacity-100',
                            'h-auto w-[240px] lg_w-[227px]',
                          )}
                          width={384}
                          height={563}
                          alt={item.name}
                        />
                        <h2 className='mt-2.5 text-[17px] leading-[1.4]  lg_hover_text-80583F'>{item.name}</h2>
                        <p className='text-[15px] leading-[1.4] '>
                          <span>{item.special_price}</span>
                          {item.special_price !== item.price ? (
                            <span className='ml-[7px] text-[#aba6a0] line-through'>{item.price}</span>
                          ) : null}
                        </p>
                      </HoverPrefetchLink>
                    </CarouselItem>
                  ) : null,
                )
              : null}
          </CarouselContent>
        </Carousel>

        {canScrollNext || canScrollPrev ? (
          <div
            onClick={() => {
              carouselApi?.scrollPrev();
              carouselApi?.scrollNext();
            }}
            className='pointer-events-auto absolute left-0 top-[146px] hidden h-10 w-8 cursor-pointer items-center justify-center bg-white/50 lg_flex'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='22'
              fill='none'
              viewBox='0 0 12 22'
            >
              <path
                stroke='#80583F'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M10.91 1L1.68 11l9.23 10'
              />
              <path
                stroke='#000'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeOpacity='0.2'
                strokeWidth='2'
                d='M10.91 1L1.68 11l9.23 10'
              />
            </svg>
          </div>
        ) : null}
        {canScrollNext || canScrollPrev ? (
          <div
            onClick={() => {
              carouselApi?.scrollNext();
            }}
            className='pointer-events-auto absolute right-0 top-[146px] hidden h-10 w-8 cursor-pointer items-center justify-center bg-white/50 lg_flex'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='22'
              fill='none'
              viewBox='0 0 12 22'
            >
              <g clipPath='url(#clip0_14494_53937)'>
                <path
                  stroke='#80583F'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='m1.386 21 9.231-10-9.23-10'
                />
              </g>
              <defs>
                <clipPath id='clip0_14494_53937'>
                  <path
                    fill='#fff'
                    d='M11.617 22H.387V0h11.23z'
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        ) : null}
      </div>

      <div className={clsx('mt-[15px] px-3 lg_hidden ')}>
        <div className={clsx('relative h-[3px] ')}>
          <div
            className={clsx(' absolute h-full w-[38.59%] bg-E7DED5')}
            style={{
              left: `${scrollProgress * 0.6141}%`,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ProductsSlider;
